import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ReportingParameters } from '@stockcare-models/ReportingParameters';
import { InstitutionsService } from '@stockcare-services/institution-service/institution.service';
import { IInstitution } from '@stockcare-models/IInstitution';
import { DatePipe } from '@angular/common';
import { IPhysicalLocation } from '@stockcare-models/IPhysical-location';
import { PhysicalLocationsService } from '@stockcare-services/physical-locations-service/physical-locations.service';
import { StockLocationsService } from '@stockcare-services/stock-locations-service/stock-locations.service';
import { IStockLocation } from '@stockcare-models/IStock-location';
import { IsSuccess } from '@stockcare-models/IsSuccess';
import { SourceOfRecordsMovementType } from '@stockcare-models/SourceOfRecordsMovementType';
import { MatSliderChange } from '@angular/material/slider';
import { TrainingRequestService } from '@stockcare-services/training-request/training-request.service';
import { TrainingRequestStatus } from '@stockcare-models/TraningRequest';

@Component({
  standalone: false,
  selector: 'app-reporting-filter',
  templateUrl: './reporting-filter.component.html',
  styleUrls: ['./reporting-filter.component.scss'],
})
export class ReportingFilterComponent implements OnInit {
  isExpanded: boolean = true;
  toggleExpansion() { this.isExpanded = !this.isExpanded; }
  @Input() fieldsToDisplay: string[] = [];
  @Input() setDateFrom: Date = new Date();
  @Input() setDateTo: Date = new Date();

  @Output() filtered = new EventEmitter();
  @Input() filterButtonText: string = 'Apply Filter';

  @Output() exportClicked = new EventEmitter();
  @Input() exportButtonText: string = 'Export';
  @Input() showExport: boolean = true;

  @Output() export2Clicked = new EventEmitter();
  @Input() export2ButtonText: string = 'Export';
  @Input() showExport2: boolean = false;

  form: UntypedFormGroup;
  institutions: IInstitution[];
  locations: IPhysicalLocation[];
  stockLocations: IStockLocation[];
  isSuccessfull = IsSuccess;
  isSuccessOptions = [];
  movementType = SourceOfRecordsMovementType;
  movementTypeOptions = [];
  timeFrom: number = 0;
  timeTo: number = 24;
  trainingTypes: string[] = [
    "Ward Billing",
    "Theatre Billing"
  ];
  trainingStatuses: TrainingRequestStatus[] = [];
  isManagedBySourceOfRecordsOptions = []

  constructor(
    private institutionService: InstitutionsService,
    private physicalLocationService: PhysicalLocationsService,
    private stockLocationService: StockLocationsService,
    private trainingRequestService: TrainingRequestService,
    private datepipe: DatePipe
  ) { }

  ngOnInit() {
    this.buildForm();
    this.isSuccessOptions = Object.keys(this.isSuccessfull);
    this.movementTypeOptions = Object.keys(this.movementType);
    this.institutionService.get().subscribe((institutions) => {
      this.institutions = institutions;
    });
    this.trainingRequestService.getAllStatuses().subscribe((trainingStatuses) => {
      this.trainingStatuses = trainingStatuses;
    });
    this.isManagedBySourceOfRecordsOptions = Object.keys(this.isSuccessfull);
  }

  get controls() {
    return this.form.controls;
  }

  isVisible(name: string) {
    if (!this.fieldsToDisplay || this.fieldsToDisplay.length === 0) {
      return true;
    }

    return this.fieldsToDisplay.filter((x) => x === name).length > 0;
  }

  onInstitutionChanged() {
    this.controls.location.setValue(null);
    if (this.controls.institution.value) {
      const institutionId = this.controls.institution.value.id;
      this.physicalLocationService.getByInstitution(institutionId).subscribe((locations) => {
        this.locations = locations;
      });
      this.stockLocationService.getByInstitution(institutionId).subscribe((stockLocations) => {
        this.stockLocations = stockLocations;
      });
    } else {
      this.stockLocations = [];
    }
  }

  private buildForm() {
    this.form = new UntypedFormGroup({
      dateFrom: new UntypedFormControl(this.datepipe.transform(this.setDateFrom, 'yyyy-MM-dd')),
      dateTo: new UntypedFormControl(this.datepipe.transform(this.setDateTo, 'yyyy-MM-dd')),
      institution: new UntypedFormControl(),
      patientNumber: new UntypedFormControl(),
      caseNumber: new UntypedFormControl(),
      location: new UntypedFormControl(),
      stockLocation: new UntypedFormControl(),
      isSuccess: new UntypedFormControl(),
      movementType: new UntypedFormControl(),
      userName: new UntypedFormControl(),
      fromLocation: new UntypedFormControl(),
      toLocation: new UntypedFormControl(),
      trainingType: new UntypedFormControl(),
      trainingStatus: new UntypedFormControl(),
      packName: new UntypedFormControl(),
      barcode: new UntypedFormControl(),
      isManagedBySourceOfRecords: new UntypedFormControl(),
      piNumber: new UntypedFormControl(),
      piReference: new UntypedFormControl()
    });
  }

  filter() {
    const parameters = new ReportingParameters();

    if (this.isVisible('timeFrom')) {
      var date = new Date(this.controls.dateFrom.value);
      var dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), this.timeFrom, 0, 0);
      dateTime.setHours(dateTime.getHours() + 2);
      parameters.DateFrom = dateTime;
    } else {
      parameters.DateFrom = this.controls.dateFrom.value;
    }

    if (this.isVisible('timeTo')) {
      var date = new Date(this.controls.dateTo.value);
      var dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), this.timeTo, 0, 0);
      dateTime.setHours(dateTime.getHours() + 2);
      parameters.DateTo = dateTime;
    } else {
      parameters.DateTo = this.controls.dateTo.value;
    }

    if (this.controls.institution.value) {
      parameters.InstitutionReferenceId = this.controls.institution.value.referenceId;
      parameters.InstitutionId = this.controls.institution.value.id;
    }

    if (this.controls.location.value) {
      parameters.PhysicalLocationReferenceId = this.controls.location.value.referenceId;
      parameters.PhysicalLocationId = this.controls.location.value.id;
    }

    if (this.controls.stockLocation.value) {
      parameters.StockLocationReferenceId = this.controls.stockLocation.value.referenceId;
      parameters.StockLocationId = this.controls.stockLocation.value.id;
    }

    if (this.controls.isSuccess.value) {
      parameters.IsSuccess = this.controls.isSuccess.value === 'True';
    }

    if (this.isVisible('movementType')) {
      parameters.movementType = this.controls.movementType.value;
    }

    if (this.controls.userName.value) {
      parameters.UserName = this.controls.userName.value;
    }

    if (this.controls.toLocation.value) {
      parameters.ToStockLocationId = this.controls.toLocation.value.id;
    }

    if (this.controls.fromLocation.value) {
      parameters.FromStockLocationId = this.controls.fromLocation.value.id;
    }

    if (this.controls.trainingType.value) {
      parameters.TrainingType = this.controls.trainingType.value;
    }

    if (this.controls.trainingStatus.value) {
      parameters.TrainingStatus = this.controls.trainingStatus.value.id;
    }

    if (this.controls.packName.value) {
      parameters.PackName = this.controls.packName.value;
    }

    if (this.controls.barcode.value) {
      parameters.Barcode = this.controls.barcode.value;
    }

    if (this.controls.isManagedBySourceOfRecords.value) {
      parameters.IsManagedBySourceOfRecords = this.controls.isManagedBySourceOfRecords.value === 'True';
    }

    parameters.CaseNo = this.controls.caseNumber.value;
    parameters.PatientNo = this.controls.patientNumber.value;
    parameters.PINumber = this.controls.piNumber.value;
    parameters.PIReference = this.controls.piReference.value;
    this.filtered.emit(parameters);
  }

  updateTimeFromValue(event: MatSliderChange) {
    this.timeFrom = event.value;
  }

  updateTimeFromSliderValue(event: MatSliderChange) {
    this.timeFrom = event.value;
  }

  updateTimeToValue(event: MatSliderChange) {
    this.timeTo = event.value;
  }

  updateTimeToSliderValue(event: MatSliderChange) {
    this.timeTo = event.value;
  }

  export() {
    this.filter();
    this.exportClicked.emit(true);
  }

  export2() {
    this.filter();
    this.export2Clicked.emit(true);
  }
}
